// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1CK12","col":"CardReaderDesc_col__1nylH","label":"CardReaderDesc_label__2UT8M"};